module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/services/service-style1/service-style1.component.scss
// module id = ./src/app/services/service-style1/service-style1.component.scss
// module chunks = main